module.exports = __webpack_public_path__ + "img/sekilas-tentang-w.dc15fd8e.svg";